export const SLOT_RENDER_MODE = {
    LANDSCAPE: 'landscape',
    PORTRAIT: 'portrait',
};
